var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.125C2.25 0.502734 1.74727 0 1.125 0C0.502734 0 0 0.502734 0 1.125V2.25V12.9375V16.875C0 17.4973 0.502734 18 1.125 18C1.74727 18 2.25 17.4973 2.25 16.875V12.375L4.51055 11.809C5.95547 11.4469 7.48477 11.6156 8.81719 12.2801C10.3711 13.057 12.1746 13.152 13.7988 12.5402L15.0188 12.0832C15.4582 11.918 15.75 11.4996 15.75 11.0285V2.32031C15.75 1.51172 14.8992 0.984375 14.175 1.34648L13.8375 1.51523C12.2098 2.33086 10.2937 2.33086 8.66602 1.51523C7.43203 0.896484 6.01523 0.741797 4.67578 1.07578L2.25 1.6875V1.125Z",
    fill: "#D75A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagred);
export default __webpack_public_path__ + "static/media/flag red.49dc36e5220a20a8831a10e226e1db53.svg";
export { ForwardRef as ReactComponent };